import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { type DateTimeFormatName } from "./catalog";
import { formatDateTime, type FormatDateTimeOptions } from "./formatDateTime";
import type { IsoTimestamp, IsoDate } from "./isoTypes";

/**
 * Returns a formatter bound to the active language. Subscribing to useTranslation
 * makes consuming components re-render when the language changes.
 */
export const useFormatDateTime = () => {
  // i18n subscription drives re-render on language change.
  const { i18n } = useTranslation();
  // Key the callback on the active language so it gets a fresh reference per language — this way
  // React.memo children that receive it as a prop also re-render when the language changes.
  return useCallback(
    (value: IsoTimestamp | IsoDate, name: DateTimeFormatName, options?: FormatDateTimeOptions) =>
      formatDateTime(value, name, options),
    [i18n.language],
  );
};
